import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { filter } from 'domutils';
import ShowPluginRelatedForm from './ShowPluginRelatedForm';
import { savePluginFormData } from '../../common/projectOnBoardUtil';
import voca from 'voca';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
import ParentDocCard from '../common/ParentDocCard';
export class AddMorePlugin extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    prevPlugin: '',
    nextPlugin: '',
    currentPlugin: '',
    completePlugins: [],
    pluginsFormData: {},
    showFinalSubmitButton: false,
    hidePluginForm: false,
    showProceedBtn: false,
  };

  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadPopularExtension({ projectId, version });
  }

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value, showProceedBtn: true });
  };

  showPluginsList = () => {
    const { popularPlugins } = this.props.projectOnBoard;
    const { currentPlugin, showProceedBtn } = this.state;
    if (currentPlugin) {
      return;
    }

    if (!popularPlugins) {
      return 'No Popular plugins';
    }
    return (
      <div className="row plugin-list-project-on-board">
        {popularPlugins.map((plugin) => (
          <div className="col-md-4 col-lg-4 col-sm-6 col-xs-6" key={plugin.code}>
            <div className="card">
              <div className="form-check"></div>
              <img
                src={require('../../common/plugin/img/' + this.synthesisCardLogoName(plugin))}
                alt={this.synthesisCardLogoName(plugin)}
              />
              <label className="form-check-label">
                <input
                  type="checkbox"
                  name={plugin.code}
                  className="form-check-input"
                  title={plugin.name}
                  onChange={this.handleChange}
                />
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
                &nbsp;
                {plugin.name}
              </label>
              {plugin.description && (
                <h6
                  className="plugin-description text-capitalize px-2 py-2 min-h"
                  title={plugin.description}
                >
                  ({voca.truncate(plugin.description, 80)})
                </h6>
              )}
            </div>
          </div>
        ))}
        {showProceedBtn ? (
          <div className="col-md-12 text-right">
            <button className="btn btn-theme-submit" onClick={this.proceedPluginInstallation}>
              <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp;Proceed: Configure Plugin
            </button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  };

  skipPluginInstallation = () => {
    const { match, history, actions } = this.props;
    const { projectId, version } = match.params;
    actions
      .changeProjectStatus({
        state: 'EXTRA_PLUGIN',
        status: 'PENDING',
        projectId,
        version,
      })
      .then((res) => {
        history.push(`/project-on-board/${version}/v/${projectId}/final-step`);
      });
  };

  proceedPluginInstallation = () => {
    const completePlugins = Object.keys(this.state).filter((plugin) => this.state[plugin] === 'on');
    let currentPlugin = '',
      nextPlugin = '';
    if (completePlugins && completePlugins.length > 0) {
      currentPlugin = completePlugins[0];
      if (completePlugins.length > 1) {
        nextPlugin = completePlugins[1];
      }
    }
    Mixpanel.track('Clicked on- Proceed: Configure Plugin on project onboard', { completePlugins });
    this.setState({
      completePlugins,
      currentPlugin,
      nextPlugin,
    });
  };

  saveAllPluginFormData = () => {
    const { pluginsFormData } = this.state;
    const { match, history, actions } = this.props;
    const { projectId, version } = match.params;
    actions.installAdditionalPlugin({ projectId, pluginsFormData, version }).then((res) => {
      history.push(`/project-on-board/${version}/v/${projectId}/final-step`);
    });
  };

  synthesisCardLogoName = (plugin) => {
    return plugin.name.toLowerCase().replace(/[\s/]/g, '-') + '-logo.png';
  };

  setNextPlugin = (pluginsFormData = {}) => {
    let { nextPlugin, completePlugins, currentPlugin } = this.state;
    if (!nextPlugin) {
      this.setState({ hidePluginForm: true, pluginsFormData, showFinalSubmitButton: true });
      return;
    }
    const prevPlugin = currentPlugin;
    currentPlugin = nextPlugin;
    const indexOfCurrentPlugin = completePlugins.findIndex((plugin) => {
      return plugin === nextPlugin;
    });
    let showFinalSubmitButton = false;
    if (indexOfCurrentPlugin < completePlugins.length) {
      nextPlugin = completePlugins[indexOfCurrentPlugin + 1];
    } else {
      nextPlugin = '';
    }
    if (!nextPlugin) {
      showFinalSubmitButton = true;
    }
    if (Object.keys(pluginsFormData).length > 0) {
      this.setState({
        nextPlugin,
        currentPlugin,
        prevPlugin,
        showFinalSubmitButton,
        pluginsFormData,
      });
    } else {
      this.setState({
        nextPlugin,
        currentPlugin,
        prevPlugin,
        showFinalSubmitButton,
      });
    }
  };
  setPrevPlugin = () => {
    let { prevPlugin, completePlugins, currentPlugin } = this.state;
    let nextPlugin = currentPlugin;
    currentPlugin = prevPlugin;
    const indexOfCurrentPlugin = completePlugins.findIndex((plugin) => {
      return plugin === prevPlugin;
    });
    if (indexOfCurrentPlugin > 0) {
      prevPlugin = completePlugins[indexOfCurrentPlugin - 1];
    } else {
      prevPlugin = '';
    }
    this.setState({ prevPlugin, currentPlugin, nextPlugin });
  };
  saveCurrentPlugin = (formData) => {
    let { pluginsFormData } = this.state;
    pluginsFormData = savePluginFormData(pluginsFormData, formData);
    this.setNextPlugin(pluginsFormData);
  };

  showCurrentPluginForm = () => {
    const {
      currentPlugin,
      prevPlugin,
      nextPlugin,
      showFinalSubmitButton,
      hidePluginForm,
      pluginsFormData,
    } = this.state;
    if (!currentPlugin) {
      return;
    }
    const {
      actions,
      projectOnBoard,
      match: { params },
    } = this.props;
    const { projectId, version } = params;
    return (
      <div className="row">
        {!hidePluginForm && (
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <ShowPluginRelatedForm
              currentPlugin={currentPlugin}
              actions={actions}
              projectOnBoard={projectOnBoard}
              projectId={projectId}
              version={version}
              saveCurrentPlugin={this.saveCurrentPlugin}
              setNextPlugin={this.setNextPlugin}
            />
          </div>
        )}

        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-left">
          {prevPlugin && !hidePluginForm && (
            <button className="btn btn-warning" onClick={this.setPrevPlugin}>
              Prev: {this.getPluginName(prevPlugin)}
            </button>
          )}
          {showFinalSubmitButton && hidePluginForm && (
            <ul>
              {Object.keys(pluginsFormData).map((plugin) => (
                <li>
                  <b>{this.getPluginName(plugin)}</b>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-right">
          {nextPlugin && (
            <button className="btn btn-primary" onClick={this.setNextPlugin}>
              <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp;Next:{' '}
              {this.getPluginName(nextPlugin)}
            </button>
          )}
          {showFinalSubmitButton && hidePluginForm && (
            <button className="btn btn-primary" onClick={this.saveAllPluginFormData}>
              <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp;Install All Plugins and goto
              next step
            </button>
          )}
        </div>
      </div>
    );
  };

  getPluginName = (code) => {
    const { popularPlugins } = this.props.projectOnBoard;
    const pluginDetail = popularPlugins.find((plugin) => plugin.code === code);
    return pluginDetail.name;
  };

  render() {
    const { completePlugins, currentPlugin, showFinalSubmitButton } = this.state;

    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-9 col-lg-9 col-sm-9 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-violet"
                  >
                    <i className={`wb ${drapcodeIcon('plugins')}`}></i>
                  </div>
                  <div className="card-content">
                    <div className="card-title-header">
                      <h4 className="card-title">
                        {currentPlugin && !showFinalSubmitButton
                          ? `${this.getPluginName(currentPlugin)}'s Configuration`
                          : 'Add more plugins in your project'}
                      </h4>
                      <div className="card-cta"></div>
                    </div>

                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div className="card-description mb-5">
                        <h5>
                          We have plenty of plugins. But some of them are very popular, almost all
                          projects need them. <br />
                          Please look at the below list of the plugins to install in your
                          application. Although it is not necessary you can always do it later.
                        </h5>
                      </div>
                    </div>
                    {this.showPluginsList()}
                    {this.showCurrentPluginForm()}
                  </div>
                </div>

                {(!completePlugins || completePlugins.length === 0) && (
                  <div className="row mx-auto">
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-right">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          this.skipPluginInstallation();
                          Mixpanel.track(
                            'Clicked on- I will do it later while Add More Plugin on project onboard',
                          );
                        }}
                      >
                        <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp;I will do it later
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <ParentDocCard></ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMorePlugin);
